export default __webpack_public_path__ + "assets/models/cb5d5f125d18543fa72cda5f9e1520c5.glb";